/**
 * @generated SignedSource<<7e75d6021772df962ce23c83c556dffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type categoryGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly option: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "categoryGroupHeader_issueTableGrouping";
};
export type categoryGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: categoryGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"categoryGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "categoryGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraJqlOptionFieldValue"
};

(node as any).hash = "90b12dc5c3b223af53b5f45469a1b3f2";

export default node;
